import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@ondit/ui";
import { useQuery } from "@tanstack/react-query";
import { DistributionWork } from "~/common/marketing/marketing";
import { api } from "~/core/api/index";
import { useT } from "~/core/i18n";
import { keys, read } from "~/core/query";
import { Section } from "~/core/ui/page";
import { Async } from "~/core/ui/states";
import { type ReadingProps, StageShell } from "~/modules/analytics/components/stage";
import { PlatformTaskHistory, useExtensionReceipts } from "~/modules/analytics/features/platform-publishing/history";

export function ProgressPage({ entityId, filters, setFilters }: ReadingProps) {
	const t = useT();
	const state = useQuery({
		queryKey: [...keys.entity(entityId), "distribution"],
		queryFn: () => api.distribution(entityId),
		...read,
	});
	useExtensionReceipts(entityId);

	return (
		<StageShell
			entityId={entityId}
			reading="progress"
			filters={filters}
			setFilters={setFilters}
			lede={t("publishFlow.intro")}
		>
			<DistributionWork brandId={entityId} />
			<PlatformTaskHistory entityId={entityId} />
			<Async state={state}>
				{(data) =>
					data.posts.length > 0 && (
						<Section title={t("publishFlow.manualRecords")}>
							<div className="table-scroll">
								<Table variant="resource">
									<TableHeader>
										<TableRow>
											<TableHead>{t("distribution.article")}</TableHead>
											<TableHead>{t("distribution.platform")}</TableHead>
											<TableHead>{t("distribution.status")}</TableHead>
										</TableRow>
									</TableHeader>
									<TableBody>
										{data.posts.map((post) => (
											<TableRow key={post.id}>
												<TableCell className="wrap">{post.title}</TableCell>
												<TableCell>{data.platforms.find((p) => p.id === post.platform_id)?.name}</TableCell>
												<TableCell>
													{post.published_url ? (
														<a href={post.published_url} target="_blank" rel="noreferrer">
															{t("publishFlow.openResult")}
														</a>
													) : (
														t("distribution.draft")
													)}
												</TableCell>
											</TableRow>
										))}
									</TableBody>
								</Table>
							</div>
						</Section>
					)
				}
			</Async>
		</StageShell>
	);
}
